import {
	SEND_FAX_REQUEST,
	SEND_FAX_SUCCESS,
	SEND_FAX_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
}

const sendFaxRequest = (state = initialState, action) => {
	switch (action.type) {
		case SEND_FAX_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			}
		case SEND_FAX_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case SEND_FAX_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default sendFaxRequest